import { ClientHelper } from '../client/CreateNswagClient';
import { fileToUploadedModel } from '../utils/fileToUploadedModel';

export class ProfileService {
  static async uploadProfileFile(token: string, file: File) {
    const profileClient = ClientHelper.createProfileClient(token);
    const uploadModel = await fileToUploadedModel(file);
    return profileClient.upload(null, uploadModel);
  }

  static async requestSuggestion(token: string, file?: File | null) {
    const profileClient = ClientHelper.createProfileClient(token);
    if (file) {
      return profileClient.suggestFromUpload(await fileToUploadedModel(file));
    }
    return profileClient.suggest();
  }
}
